import React, { Fragment } from "react";
import _ from "lodash";
import { connect as reduxConnect } from "react-redux";
import { connect, replace } from 'formik';
import { compose} from "redux";
import IconButton from "@material-ui/core/IconButton";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import {Dialog, DialogTitle, Grid, FormHelperText,FormLabel} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import {AutoCompleteInput, MoneyInput, PercentInput, RadioInput, TextAreaInput} from 'components/Global/FastFormikMaterial';
import Dropdown from 'components/Global/Dropdown/Dropdown';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';

const burndownOptions = [{name: 'Yes', value: '1'}, {name: 'No', value: '0'}]
const FormGrid = styled.div`
  padding:0 20px 20px 20px;
`
const CustomFormLabel = styled(FormLabel)`
  &&& {
    font-size:17px;
  }
`
const VerticalSpace = styled.div`
  height:32px;
  width:100%;
`
const ButtonWrapperGrid = styled(Grid)`
  margin-top:16px;
`
const FullHeight = styled.div`
  min-height:400px;
`
const StyledDropdown = styled(Dropdown)`
  margin-top:16px;
`
const StyledTextAreaInput = styled(TextAreaInput)`& {width:100%;}`
const Error = styled.div`
  color:red;
`
const styles = theme => ({
  dialogPaper: {
    'max-width':'600px',
    'font-size': '13px',        
  },
  dialogTitle: {    
    padding: '8px 0 0 20px'
  }
})

const ErrorMessage = ({message}) => (
  <Error>{message}</Error>
)

class PersonalGuarantorModalForm extends React.Component {
  state ={
    hasErrors:false,
    errorMessage: ''
  }
  onCancel = () => {
    this.props.onClose();
  }
  closeModal = () => {
    this.props.onClose();  
  };   
  
  getFields = (fields) => {
    const {formik,index} = this.props;
    const {values} = formik;
    const foundValues = {};
    for(let i = 0; i < fields.length;i++){
      let field = fields[i];
      let val = _.get(values, `personalGuarantors[${index}].${field}`);    
      foundValues[field] = val;
    }
    return foundValues;
  }
  
  render() {
    const {classes, isOpen,index,formik} = this.props;
    const hasErrors = false;
    const errorMessage = "";    
    const {values} = formik;        
    return (
      <Fragment>        
        <Dialog open={isOpen} 
          onClose={this.closeModal} 
          fullWidth 
          maxWidth="md" 
          classes={{paper: classes.dialogPaper}}>
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between">
            <DialogTitle classes={{root: classes.dialogTitle}}>Personal Guarantor</DialogTitle>
            <IconButton style={{ marginRight: 8,marginTop:8 }} onClick={this.closeModal}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>
          <FormGrid>
          <FullHeight>
            <Grid container alignContent="space-between">
              <Grid item xs={5}>
                <AutoCompleteInput 
                  formik={formik}
                  label="Select a guarantor"
                  id="dropdownForpersonalGuarantor"
                  fieldName={`personalGuarantors[${index}].contactId`}
                  options={_.get(values, 'ancillary.contacts', [])}
                  selectName='label'
                  selectValue='value'/>
              </Grid>
              <Grid item xs={7}></Grid>             
              <VerticalSpace/>
              <Grid item xs={4}>
                <MoneyInput 
                  label="Net Worth"
                  id="personalGuarantorNetWorthField"
                  fieldName={`personalGuarantors[${index}].netWorth`}/>                                    
              </Grid>
              <Grid item xs={4}>
                <MoneyInput 
                  label="Liquidity"
                  id="personalGuarantorLiquidityField"
                  fieldName={`personalGuarantors[${index}].liquidity`}/>
              </Grid>
              <Grid item xs={4}>
                <PercentInput 
                  label="Leverage"
                  id="personalGuarantorLeverageField"
                  fieldName={`personalGuarantors[${index}].leverage`}/>
              </Grid>
              <VerticalSpace/>
              <Grid container item xs={12} alignItems="center">
                <Grid item xs={4}>
                    <PercentInput 
                      label="Recourse Amount"
                      id="personalGuarantorRecourseAmountField"
                      fieldName={`personalGuarantors[${index}].recoursePercent`}/>
                </Grid>
                <Grid item xs={4}>
                  <CustomFormLabel>Burndown</CustomFormLabel>
                  <RadioInput 
                      id="personalGuarantorBurndownRadio"
                      label="Burndown"
                      options={burndownOptions}
                      fieldName={`personalGuarantors[${index}].burndown`}/>
                </Grid>
              </Grid>
              <VerticalSpace/>
              <Grid item xs={8}>
                <StyledTextAreaInput
                  label="Notes"
                  id="personalGuarantorNotesField"
                  fieldName={`personalGuarantors[${index}].notes`}/>
              </Grid>
              <Grid item xs={4}></Grid>
              <VerticalSpace/>
              <Grid item xs={8}>
                <StyledTextAreaInput
                  label="Reference"
                  id="personalGuarantorReferenceField"
                  fieldName={`personalGuarantors[${index}].reference`}/>
              </Grid>
             </Grid>
          </FullHeight>
            <ButtonWrapperGrid container direction="row" justify="flex-end">
              {hasErrors && <ErrorMessage message={errorMessage}/>}
              <SecondaryButton id="personalGuarantorCancelButton" onClick={this.onCancel}>Cancel</SecondaryButton>
              <PrimaryButton id="personalGuarantorAddButton" onClick={() => this.props.onEdit()}>{this.props.isAdding ? 'Add' : 'Save'}</PrimaryButton>
            </ButtonWrapperGrid>
          </FormGrid>
        </Dialog>
      </Fragment>
    );
  }
}

function mapStateToProps({}) {
  return {
    
  };
}


export default compose(
  connect,
  reduxConnect(
    mapStateToProps,
    {
      
    }
  ),
  withStyles(styles)
)(PersonalGuarantorModalForm);